import React, { useState, useEffect } from 'react';
    import { supabase, isSupabaseConfigured } from '../../config/supabase';
    import { FiCheckCircle, FiAlertCircle, FiWifi, FiWifiOff } from 'react-icons/fi';
    import SafeIcon from '../../common/SafeIcon';

    const ConnectionStatus = () => {
      const [connectionStatus, setConnectionStatus] = useState('checking');
      const [error, setError] = useState('');

      useEffect(() => {
        checkConnection();
      }, []);

      const checkConnection = async () => {
        if (!isSupabaseConfigured()) {
          setConnectionStatus('not_configured');
          return;
        }

        try {
          // Test basic connection
          const { data, error } = await supabase
            .from('teams')
            .select('count')
            .limit(1);

          if (error) {
            setConnectionStatus('error');
            setError(error.message);
          } else {
            setConnectionStatus('connected');
          }
        } catch (err) {
          setConnectionStatus('error');
          setError(err.message);
        }
      };

      const getStatusInfo = () => {
        switch (connectionStatus) {
          case 'connected':
            return {
              icon: FiCheckCircle,
              color: 'text-green-500',
              bgColor: 'bg-green-50',
              borderColor: 'border-green-200',
              message: 'Connected to Supabase successfully'
            };
          case 'not_configured':
            return {
              icon: FiWifiOff,
              color: 'text-yellow-500',
              bgColor: 'bg-yellow-50',
              borderColor: 'border-yellow-200',
              message: 'Supabase not configured. Please check your environment variables.'
            };
          case 'error':
            return {
              icon: FiAlertCircle,
              color: 'text-red-500',
              bgColor: 'bg-red-50',
              borderColor: 'border-red-200',
              message: `Connection error: ${error}`
            };
          case 'checking':
          default:
            return {
              icon: FiWifi,
              color: 'text-blue-500',
              bgColor: 'bg-blue-50',
              borderColor: 'border-blue-200',
              message: 'Checking connection...'
            };
        }
      };

      const statusInfo = getStatusInfo();

      if (connectionStatus === 'connected') {
        return null; // Don't show status when connected
      }

      return (
        <div className={`fixed top-4 right-4 z-50 p-4 rounded-lg border ${statusInfo.bgColor} ${statusInfo.borderColor} shadow-lg max-w-md`}>
          <div className="flex items-start space-x-3">
            <SafeIcon icon={statusInfo.icon} className={`h-5 w-5 ${statusInfo.color} flex-shrink-0`} />
            <div>
              <p className={`text-sm font-medium ${statusInfo.color}`}>
                {statusInfo.message}
              </p>
              {connectionStatus === 'not_configured' && (
                <p className="text-xs text-gray-600 mt-1">
                  Make sure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY are set in your environment.
                </p>
              )}
            </div>
          </div>
        </div>
      );
    };

    export default ConnectionStatus;